import React, { useState } from 'react'

export default function HomeNewsTab({ news }) {
    return (
        <div className="h-[120px] items-center w-full mx-auto">
            {

                <section className="antialiased text-an_green-dark px-4">
                    <div className="flex flex-col justify-center pt-4">
                        <div className="p-3">
                            <div>
                                { 
                                    news ?
                                        news.map((newsItem, index) => {
                                            return (
                                                <div key={index} className={`border-b py-4 my-4 border-an_green-dark`}>
                                                    <small className="text-left text-an_green-dark pb-2 block">{new Date(newsItem?.created_at).toDateString()}</small>

                                                    <h2 className="font-semibold text-an_green-dark text-4xl">{newsItem?.title}</h2>
                                                    <div dangerouslySetInnerHTML={{__html: newsItem?.HtmlContent}}></div>
                                                </div>
                                            )
                                        })
                                        : 'Slow news day' 
                                }
                            </div>
                            
                        </div>
                    </div>
                </section>
            }
        </div>
    )
}